var _svg;
import React from "react";
const EscalationReview = ({
  ...rest
}) => {
  return _svg || (_svg = /*#__PURE__*/React.createElement("svg", {
    width: "50",
    height: "50",
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "22",
    cy: "22",
    r: "22",
    fill: "#F9D4DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8515 17.6466L24.3515 12.1466C24.1572 11.956 23.8461 11.956 23.6517 12.1466C23.4545 12.3398 23.4513 12.6563 23.6445 12.8535L28.291 17.5H18.8887C16.466 17.5028 14.5027 19.466 14.5 21.8887V31.5C14.5 31.5002 14.5 31.5004 14.5 31.5006C14.5002 31.7766 14.724 32.0002 15 32C15.0002 32 15.0004 32 15.0006 32C15.2766 31.9998 15.5002 31.776 15.5 31.5V21.8887C15.5024 20.0182 17.0181 18.5024 18.8887 18.5H28.291L23.6445 23.1465C23.5508 23.2403 23.4981 23.3674 23.4981 23.5C23.4981 23.7761 23.7219 24 23.998 24C24.1307 24.0002 24.2579 23.9475 24.3515 23.8535L29.8515 18.3535C29.8516 18.3535 29.8516 18.3534 29.8517 18.3534C30.0468 18.1582 30.0468 17.8417 29.8515 17.6466Z",
    fill: "black",
    "fill-opacity": "0.87"
  })));
};
export default EscalationReview;